export default {"src":"/_next/static/media/CheckBoxChecked.46edea10.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};